export const SOURCE_COLORS = ['#ffb52e', '#ff616b', '#9852ff', '#1689ff', '#00b58a', '#ff92a2', '#77caff', '#b4acef'];
export const STATUS_COLORS = { PROCESSED: '#00b47b', FAULTED: '#ff4f63', UPDATE_FAULTED: '#ff970d' };
export const number = (value) => Number(value || 0).toLocaleString();
export const statusLabel = (value) => String(value).toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
export const money = (value) => `$${Number(value || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function summaryCount(data, field, entity) {
  const rawReported = data?.[field];
  const reported = rawReported == null || rawReported === '' ? NaN : Number(rawReported);

  const statusCounts = Object.values(data?.statusCounts?.[entity] || {});
  const statusTotal = statusCounts.reduce((sum, count) => sum + (Number(count) || 0), 0);
  if (statusTotal > 0) return statusTotal;

  if (Number.isFinite(reported) && reported > 0) return reported;

  const sourceTotal = (data?.SystemcodeData || []).reduce((sum, row) => sum + (Number(row?.[field]) || 0), 0);
  if (sourceTotal > 0) return sourceTotal;

  return Number.isFinite(reported) ? reported : null;
}

export function monthlySeries(data, year) {
  const rows = data?.monthlyData || [];
  return Array.from({ length: 12 }, (_, index) => {
    const matches = rows.filter((row) => Number(row.year) === Number(year) && Number(row.month ?? row.Month) === index + 1);
    return { month: index + 1, label: new Date(Number(year), index, 1).toLocaleString(undefined, { month: 'short' }),
      value: matches.reduce((sum, row) => sum + Number(row.totalInvoices || 0), 0) };
  });
}

export function sourceRows(data, field = 'totalInvoices') {
  return [...(data?.SystemcodeData || [])].sort((a, b) => Number(b.totalInvoices || 0) - Number(a.totalInvoices || 0))
    .map((row, index) => ({ ...row, id: row.SourceSystemCode || 'Unknown', value: Number(row[field] || 0), color: SOURCE_COLORS[index % SOURCE_COLORS.length] })).sort((a, b) => b.value - a.value);
}

export function csvText(headers, rows) {
  const escape = (value) => {
    let text = String(value ?? '');
    if (/^[=+@\-\t\r]/.test(text) && typeof value !== 'number') text = `'${text}`;
    return `"${text.replace(/"/g, '""')}"`;
  };
  return '\uFEFF' + [headers, ...rows].map((row) => row.map(escape).join(',')).join('\r\n');
}

export function downloadCsv(headers, rows, filename) {
  const url = URL.createObjectURL(new Blob([csvText(headers, rows)], { type: 'text/csv;charset=utf-8;' }));
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// Only forward filters that the destination actually supports.
export function destinationLink(kind, scope = {}, customer, period) {
  const params = new URLSearchParams();
  let path = '/reports';
  if (kind === 'Customer') {
    path = '/customers';
    if (scope.sourceUser && scope.sourceUser !== 'all') params.set('source', scope.sourceUser);
    else if (scope.sources?.length) scope.sources.forEach((source) => params.append('source', source));
    if (customer?.SourceCustomerID) params.set('search', customer.SourceCustomerID);
  } else if (kind === 'Invoice') {
    path = '/invoices';
    if (customer?.WorkdayCustomerBusinessEntityName) params.set('search', customer.WorkdayCustomerBusinessEntityName);
    if (scope.status && scope.status !== 'ALL') params.set('status', scope.status);
    if (period) { params.set('fromDate', period.fromDate); params.set('toDate', period.toDate); }
  } else {
    path = kind === 'Contact' ? '/customers/contacts/all' : '/reports';
    for (const key of ['company', 'sourceUser', 'view', 'customerId', 'sourceCustomerId', 'customerLoadId', 'customerSourceCode', 'entity', 'status', 'year']) {
      if (scope[key] != null) params.set(key, scope[key]);
    }
  }
  const query = params.toString();
  return path + (query ? `?${query}` : '');
}
